import store from '@/state/store'
import router from '@/router'

window.onmessage = async (e) => {
  const { customerPortal } = e.data
  if (customerPortal) {
    store.commit('setPortalData', customerPortal)
    await store.dispatch('updateStoreFromPortal')
    router.push({ name: 'products-list' })
  }
}
